import { useCallback } from 'preact/hooks';
import useTiltifyConfig from '@hooks/useTiltifyConfig.js';

export function useTiltifyUserConfigValidator() {
  const tiltifyConfig = useTiltifyConfig();
  return useCallback(() => {
    return (
      tiltifyConfig.tiltifyUserID !== null &&
      tiltifyConfig.tiltifyUserID.length > 0
    );
  }, [tiltifyConfig.tiltifyUserID]);
}

export function useTiltifyCampaignConfigValidator() {
  const tiltifyConfig = useTiltifyConfig();
  const userConfigValidator = useTiltifyUserConfigValidator();

  return useCallback(() => {
    return (
      tiltifyConfig.tiltifyCampaignID !== null &&
      tiltifyConfig.tiltifyCampaignID.length > 0 &&
      userConfigValidator()
    );
  }, [tiltifyConfig.tiltifyCampaignID, userConfigValidator]);
}
